const video = function () {
  $('.js-video-play').on("click", function (e) {
    e.preventDefault();

    let video;
    $('.js-video-preview').addClass('is--hidden');

    if ($(this).data('video')) {
      const videoContainer = $('#' + $(this).data('video'));
      video = $('#' + $(this).data('video')).find('video').get(0);

      if (video.paused) {
        video.play();
        videoContainer.addClass('is--visible');
        $(this).addClass('is--playing');

      } else {
        video.pause();
        videoContainer.removeClass('is--visible');
      }


      $(document).mouseup(function (e) {
        var container = $('.video');

        // if the target of the click isn't the container nor a descendant of the container
        if (
          !container.is(e.target) &&
          container.has(e.target).length === 0
        ) {
          video.pause();
          videoContainer.removeClass('is--visible');
        }
      });

      $('.js-video-close').click(function () {
        video.pause();
        videoContainer.removeClass('is--visible');
      });


    } else {
      togglePlay($(this));
    }
  });


  // preload meta data for iOS
  $('.js-video-play').each(function () {
    const video = $(this).find('video');
    const container = $(this);

    video.bind('loadeddata', function (e) {
      video.get(0).pause();

    });
  });

  function togglePlay(container) {
    const video = container.find('video').get(0);

    if (video.paused) {
      video.play();
      container.find('video').addClass('is--visible');
      container.removeClass('is--paused');
      container.addClass('is--playing');

    } else {
      video.pause();
      container.addClass('is--paused');
      container.removeClass('is--playing');

    }
  }
}

export default video;


